var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.4,168.4c-4.1-52.9-48.8-94.7-103.3-94.7-14.4,0-28.4,2.9-41.4,8.6-26.8-43.4-74.5-70.4-127-70.4-82.1,8.88178e-15-148.9,66.1-148.9,147.3-1.06581e-14,14.3 2.1,28.5 6.3,42.2-11.1,15.8-17.1,34.5-17.1,53.8 0,51.8 42.6,94 94.9,94h69c11.3,0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-69c-29.8,0-54.1-23.9-54.1-53.2 0-13.3 5.1-26 14.2-35.8 5.4-5.8 6.9-14.1 4-21.5-5-12.5-7.5-25.5-7.5-38.7 0-58.7 48.5-106.5 108.1-106.5 43.9,0 81.8,26.4 99.9,65.8 6.9,15.1 22.5,14.3 31,8.5 11.3-7.7 24-12.4 37.6-12.4 34.6,0 63.2,27.7 62.7,61.7-0.2,13 3,23.6 15.8,27 24.4,6.4 42.5,27.1 42.5,51.9 0,29.3-24.3,53.2-54.1,53.2h-81.5c-11.3,0-20.4,9.1-20.4,20.4 0,11.3 9.1,20.4 20.4,20.4h81.5c52.3,0 94.9-42.2 94.9-94 0.1-38.2-23.7-72.5-58.5-86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.7,461.2h-268.8c-12.5,0-22.7-10.2-22.7-22.7 0-12.5 10.2-22.7 22.7-22.7h268.8c12.5,0 22.7,10.2 22.7,22.7-5.68434e-14,12.5-10.2,22.7-22.7,22.7zm0-86.3h-114v-68.9c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v68.8h-114c-35,0-63.6,28.5-63.6,63.6 0,35 28.5,63.6 63.6,63.6h268.8c35,0 63.6-28.5 63.6-63.6-0.1-35-28.6-63.5-63.6-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.4,266.5c9.3-9 24.5-9.1 33.7,0 10.7,10.6 24.9,3.6 28.9-0.5 7.8-8.1 7.6-21.1-0.5-28.9-24.9-24.1-65.5-24-90.4,0-8.1,7.8-8.3,20.8-0.5,28.9 7.8,8.1 20.7,8.3 28.8,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.7,223.5c11.7,11.3 24.9,3.6 28.9-0.5 7.8-8.1 7.6-21-0.5-28.9-49.5-47.8-130-47.7-179.5,0-8.1,7.8-8.3,20.8-0.5,28.9 7.8,8.1 20.8,8.3 28.9,0.5 33.7-32.6 88.9-32.8 122.7,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerlogo);
export default __webpack_public_path__ + "static/media/serverlogo.fe308423c302e111d19729f6a03a377f.svg";
export { ForwardRef as ReactComponent };